export default [{
  path: '/implantacoes',
  component: {
    name: 'implantacoesBase',
    template: '<router-view />',
    meta: {
      resource: 'implantacoes',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'implantacoes',
    component: () => import('@/app-modulo/comuns/implantacoes/ImplantacoesView.vue'),
    meta: {
      resource: 'implantacoes',
      action: 'read',
      navActiveLink: 'implantacoes',
      pageTitle: 'Implantações',
      breadcrumb: [
        {
          text: 'Implantações',
          to: { name: 'implantacoes' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-cliente-saas',
    component: () => import('@/app-modulo/comuns/implantacoes/components/cadastro/Implantacoes.vue'),
    meta: {
      resource: 'implantacoes',
      action: 'create',
      nacActiveLink: 'implantacoes',
      pageTitle: 'Implatanções',
      breadcrumb: [
        {
          text: 'Implantações',
          to: { name: 'implantacoes' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-cliente-saas' },
          active: true,
        },
      ],
    },
  }],
}]
